import event from '../util/NotifierManager';
import {
  INDEX,
  EVENT_SWITCH_VIEW
} from '../util/constant';
import Index from './Index';
import Map from './Map';

import ParkOverview  from './subject/ParkOverview';
import ParkPlanning  from './subject/ParkPlanning';
import ParkConstruction from './subject/ParkConstruction';
import ParkInvestment from './subject/ParkInvestment';
import ParkOperation from './subject/ParkOperation';
import ParkBuilding from './subject/ParkBuilding';

export default class Main {
	constructor() {
		this.g2d = new ht.graph.GraphView();
    	this.initView();
    	this.event = event;
  	}

  	initView() {
		const g2d = this.g2d;
    	// 选中边框为0
    	g2d.getSelectWidth = () => 0;
    	// 禁止缩放
    	g2d.setZoomable(false);
    	// 禁止平移
    	g2d.setPannable(false);
    	// 禁止框选
    	g2d.setRectSelectable(false);
    	// 隐藏滚动条
    	g2d.setScrollBarVisible(false);
    	// 禁止图元移动
    	g2d.setMovableFunc(() => false);

		const handler = e => {
			if (g2d.getDataAt(e)) {
				e.stopPropagation();
			}
		};
		g2d.getView().addEventListener('mousedown', handler);
		g2d.getView().addEventListener('touchstart', handler);
		g2d.getView().addEventListener('wheel', handler);

		const pageMap = this.pageMap = new Map(this);
		this.page2D = new Index(this);

		// 专题
		// 园区总览
		this.parkOverview = new ParkOverview(this);
		// 园区规划
		this.parkPlanning = new ParkPlanning(this); 
		// 园区建设
		this.parkConstruction = new ParkConstruction(this);
		// 园区招商
		this.parkInvestment = new ParkInvestment(this);
		// 园区运营
		this.parkOperation = new ParkOperation(this);
		// 智慧楼宇
		this.parkBuilding = new ParkBuilding(this);
		
		const map = pageMap.map;
		g2d.addToDOM(map.graph3dView.getView());
		map.addToDOM();

		this.switch();
	}

	switch (key = INDEX) {
		event.fire(EVENT_SWITCH_VIEW, key);
	}
}
